import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { routeColors } from '../config/colors';

export function useRouteColor(defaultColor = { bg: 'bg-transparent', nav: 'bg-transparent' }) {
  const { pathname } = useLocation();

  // Memoizamos para no recalcular en cada render innecesario
  return useMemo(() => {
    return routeColors[pathname] || defaultColor;
  }, [pathname, defaultColor]);
}